import axios from '@src/utils/axios'

const module = 'company'
const axiosInstance = axios(false);

export default {
  'pagination': (ctx, data) => axiosInstance.get(`/${module}/paginate`, { params:data }),
  'get_source': (ctx, data) => axiosInstance.get(`/${module}/get_source`, {params:data}),
  'findSourceCompany': (ctx, data) => axiosInstance.get(`/${module}/find_source`, {params:data}),
  'findCompanySource': (ctx, data) => axiosInstance.get(`/${module}/find_company_source`, {params:data}),
  'create': (ctx, data) => axiosInstance.post(`/${module}`, data),
  'createNote': (ctx, data) => axiosInstance.post(`/${module}/create_note`, data),
  'activate':  (ctx, data) =>  axiosInstance.post(`/${module}/activate`, data),
  'getVincereCompany': (ctx, data) => axiosInstance.get(`vincere/get_company`, data),
  'getVincereApplication': (ctx, data) => axiosInstance.get(`vincere/get_application`, data),
  'getVincereCandidate': (ctx, data) => axiosInstance.get(`vincere/get_candidate`, data),
  'update': (ctx, data) => {
    return axiosInstance.put(`/${module}/` + data.id, data)
  },
  'updateSourceCompany': (ctx, data) => {
    return axiosInstance.put(`/${module}/update_source_company/` + data.id, data)
  },
  'delete_source_company': (ctx, data) => {
    return axiosInstance.delete(`/${module}/source_company/` + data.id, data)
  },
  'editContactPerson': (ctx, data) => {
    return axiosInstance.put(`/${module}/update_contact_person/` + data.id, data)
  },
  'setCPDefault': (ctx, data) => {
    return axiosInstance.put(`/${module}/set_default_contact_person/` + data.id, data)
  },
  'find': async (ctx, data) => {
    return await axiosInstance.get(`/${module}/` + data.id)
  },

  'getContactPersons': async (ctx, data) => {
    return await axiosInstance.get(`/${module}/get_contact_person`, {params:data})
  },
  'getCompanyCP': async (ctx, data) => {
    return await axiosInstance.get(`/${module}/get_company_cp`, { params:data })
  },
  'createContactPerson': (ctx, data) => axiosInstance.post(`/${module}/create_contact_person`, data),
  'findContactPerson': async (ctx, data) => {
    return await axiosInstance.get(`/${module}/find_contact_person/` + data.id)
  },

  'findByToken': async (ctx, data) => {
    return await axiosInstance.get(`/${module}/find_by_token/` + data)
  },
  'all': (ctx, data) => axiosInstance.get(`/${module}/all`, {params:data}),
  'getAll': () => axiosInstance.get(`/${module}/get_all`),
  'uploadAvatar': (ctx, data) => axiosInstance.post(`/${module}/upload_avatar`, data),
  'sendLink': (ctx, data) => axiosInstance.post(`/${module}/send_link`, data),

  'delete': (ctx, data) => {
    return axiosInstance.delete(`/${module}/` + data.id, data)
  },
}